import { render, staticRenderFns } from "./Ticket.vue?vue&type=template&id=23975e18&scoped=true"
import script from "./Ticket.vue?vue&type=script&lang=js"
export * from "./Ticket.vue?vue&type=script&lang=js"
import style0 from "./Ticket.vue?vue&type=style&index=0&id=23975e18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23975e18",
  null
  
)

/* custom blocks */
import block0 from "./Ticket.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)
import block1 from "@/locales/global.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuilds%2Ftsno%2Ffrechdax%2Ffrechdax-essen%2Fweb%2Fwebapp%2Fsrc%2Fviews%2FTicket.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports